import { Link } from "react-router-dom";
import { FileText, Receipt, ShieldCheck, Buildings, ArrowSquareOut } from "@phosphor-icons/react";

const DOCS = [
  {
    to: "/mentions-legales",
    icon: Buildings,
    title: "Mentions légales",
    desc: "Identification de l'éditeur, hébergeur, propriété intellectuelle.",
  },
  {
    to: "/cgu",
    icon: FileText,
    title: "Conditions générales d'utilisation",
    desc: "Règles d'usage du service, obligations praticien et patient, secret médical.",
  },
  {
    to: "/cgv",
    icon: Receipt,
    title: "Conditions générales de vente",
    desc: "Modalités d'abonnement, tarifs, résiliation, médiation de la consommation.",
  },
  {
    to: "/confidentialite",
    icon: ShieldCheck,
    title: "Politique de confidentialité",
    desc: "Données personnelles, sous-traitants, durées de conservation, droits RGPD.",
  },
];

export default function LegalPanel() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold tracking-tight text-[#1E3A5F] mb-1">Documents légaux</h2>
        <p className="text-sm text-[#5F758F]">Retrouvez ici l'ensemble des documents contractuels et réglementaires de Questiomed.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {DOCS.map(({ to, icon: Icon, title, desc }) => (
          <Link
            key={to}
            to={to}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white border border-[#E1E9F0] rounded-[14px] p-5 flex items-start gap-4 hover:border-[#3A8FA5] hover:shadow-[0_2px_8px_rgba(58,143,165,0.08)] transition-all"
            data-testid={`legal-link-${to.replace(/\//g, "")}`}
          >
            <span className="w-10 h-10 rounded-[10px] bg-[#E6F1F5] border border-[#C7DEE6] flex items-center justify-center shrink-0">
              <Icon size={18} weight="duotone" className="text-[#3A8FA5]" />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <p className="font-semibold text-[#1E3A5F] text-[15px]">{title}</p>
                <ArrowSquareOut size={13} className="text-[#5F758F] group-hover:text-[#3A8FA5] shrink-0" />
              </div>
              <p className="text-[13px] text-[#5F758F] leading-relaxed mt-1">{desc}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="rounded-[10px] bg-[#F4F7FB] border border-[#E1E9F0] px-4 py-3 text-[13px] text-[#5F758F]">
        Une question ? Contactez-nous à <a href="mailto:contact@questiomed.fr" className="text-[#3A8FA5] font-semibold underline underline-offset-2">contact@questiomed.fr</a> · Pour toute demande RGPD : <a href="mailto:dpo@questiomed.fr" className="text-[#3A8FA5] font-semibold underline underline-offset-2">dpo@questiomed.fr</a>.
      </div>
    </div>
  );
}
